import { useTranslation } from 'react-i18next';

export default function AutoPaymentEmptyCard(): JSX.Element {
  const { t } = useTranslation();
  return (
    <div className="mt-3">
      <div className="border border-ice-blue bg-white rounded h-32 flex justify-center items-center">
        <div className="N_14_R text-brown-grey text-center" dangerouslySetInnerHTML={{ __html: t('product/auto-payment/no_data') }} />
      </div>
    </div>
  );
}
